/* eslint-disable react/prop-types */
import React, { Children } from "react";

import Conditional from "../Conditional/Conditional";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import BorderBox from "@src/sharedComponents/BorderBox/BorderBox";
import BorderBoxBody from "@src/sharedComponents/BorderBox/BorderBoxBody";
import BorderBoxHeader from "@src/sharedComponents/BorderBox/BorderBoxHeader";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import ItemListItem from "./ItemListItem";

import styles from "./ItemList.module.css";

interface Props {
  isLoading: boolean;
  className?: string;
  children:
    | React.ReactElement<typeof ItemListItem>
    | Array<React.ReactElement<typeof ItemListItem>>;
  title: string;
  maxHeight?: number;
}

interface ItemListComponent extends React.FC<Props> {
  ItemListItem: typeof ItemListItem;
}

const ItemList: ItemListComponent = ({
  isLoading,
  className,
  children,
  title,
}) => {
  const totalItems = Children.toArray(children).length;

  const skeletonItems = Array.from({ length: 3 }, (_, index) => (
    <div key={index} className={styles.item}>
      <Skeleton className={styles.skeletonRow} />
    </div>
  ));

  return (
    <BorderBox className={toClassName(styles.container, className)}>
      <BorderBoxHeader
        start={
          <Text variant="title3" color="text">
            {title}
          </Text>
        }
      />
      <BorderBoxBody className={styles.body}>
        {isLoading ? (
          skeletonItems
        ) : totalItems === 0 ? (
          <Text variant="body" color="textSubtle">
            No items available.
          </Text>
        ) : (
          <Conditional condition={true} onlyAllow={ItemListItem}>
            {children}
          </Conditional>
        )}
      </BorderBoxBody>
    </BorderBox>
  );
};

ItemList.ItemListItem = ItemListItem;

export default ItemList;
